module.exports = __webpack_public_path__ + "img/shanhu-tree2.56f4cf63.png";